import {
    faAngleDown,
    faAnglesUpDown,
    faAngleUp,
    faArrowRightFromBracket,
    faAsterisk,
    faBarsFilter,
    faBoxesStacked,
    faCabinetFiling,
    faCalculator,
    faCartXmark,
    faCheck,
    faChevronDown,
    faCircle,
    faCircleCheck,
    faCircleQuestion,
    faCircleStar,
    faCircleX,
    faContainerStorage,
    faCopy,
    faDoorOpen,
    faEye,
    faFile,
    faFileExport,
    faFileImport,
    faGem,
    faHexagonImage,
    faMinus,
    faPalette,
    faPencil,
    faPersonDigging,
    faPersonToDoor,
    faPrint,
    faQrcode,
    faSave,
    faServer,
    faSheetPlastic,
    faShelves,
    faShoppingBasket,
    faSquare,
    faSquareDashedCirclePlus,
    faTag,
    faText,
    faTimes,
    faTrashCanArrowUp,
    faTrashCanXmark,
    faUser,
    faUsers,
    faUserSecret,
    faX,
    type IconDefinition,
} from "@fortawesome/pro-light-svg-icons";
import { faEllipsis } from "@fortawesome/pro-light-svg-icons/faEllipsis";

export const lightIcons: IconDefinition[] = [
    faAngleDown,
    faAngleUp,
    faAnglesUpDown,
    faPrint,
    faArrowRightFromBracket,
    faAsterisk,
    faBarsFilter,
    faBoxesStacked,
    faCalculator,
    faCartXmark,
    faCheck,
    faCircleQuestion,
    faDoorOpen,
    faEye,
    faTag,
    faChevronDown,
    faCircle,
    faCircleCheck,
    faTrashCanXmark,
    faTrashCanArrowUp,
    faCircleStar,
    faCopy,
    faEllipsis,
    faFile,
    faFileImport,
    faHexagonImage,
    faPalette,
    faPencil,
    faPersonDigging,
    faPersonToDoor,
    faQrcode,
    faSave,
    faShoppingBasket,
    faShelves,
    faSheetPlastic,
    faSquareDashedCirclePlus,
    faSquare,
    faText,
    faTimes,
    faUser,
    faUserSecret,
    faUsers,
    faX,
    faCircleX,
    faGem,
    faGem,
    faMinus,
    faTag,
    faSheetPlastic,
    faCabinetFiling,
    faContainerStorage,
    faServer,
    faFileExport,
];
